if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				if (!this.form) return;
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					// this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				// this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				// processing state on the button that actually triggered the add
				const atcBtn = evt.submitter || this.submitButton;
				if (window.setButtonLoading) window.setButtonLoading(atcBtn, true);

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							// A quantity capped by availability still changes the cart but
							// comes back as a 422 (e.g. "Only 1 item was added to your cart
							// due to availability."). The default handler returned here, so
							// the header count stayed stale and the drawer never opened
							// until a reload. Refresh the cart UI and slide the drawer out
							// like a normal add: use the re-rendered sections if Shopify
							// sent them, otherwise fetch them.
							if (this.cart) {
								if (response.sections) {
									this.cart.renderContents(response);
								} else {
									this.refreshCartSections();
								}
							}

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							// this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (window.setButtonLoading) window.setButtonLoading(atcBtn, false);
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			// Fetch the cart's sections fresh and hand them to the cart element's
			// renderContents, which updates the header count and opens the drawer.
			// Used when an add mutated the cart but Shopify returned a 422 without
			// the re-rendered sections in the body.
			refreshCartSections() {
				if (!this.cart || typeof this.cart.getSectionsToRender !== "function")
					return;
				const ids = this.cart
					.getSectionsToRender()
					.map((section) => section.id);
				fetch(`${window.location.pathname}?sections=${ids.join(",")}`)
					.then((response) => response.json())
					.then((sections) => {
						this.cart.renderContents({ sections });
					})
					.catch((e) => {
						console.error(e);
					});
			}
		}
	);
}
